module.exports = __webpack_public_path__ + "static/img/kv-m.61b8997a.png";